import React, { ElementType, ReactNode } from 'react'
import { isAnyChunkLonger } from 'utils'
import classNames from 'classnames'

const DEFAULT_MAX_CHARS_PER_NAME = 15

interface Props {
  children: ReactNode
  compareString: string
  className?: string
  classLongText: string
  maxChars?: number
  as?: ElementType
}

const ResponsiveText = ({
  children,
  compareString,
  classLongText,
  className = '',
  maxChars = DEFAULT_MAX_CHARS_PER_NAME,
  as: Tag = 'p',
}: Props) => {
  return (
    <Tag
      className={classNames(className, {
        [classLongText]: isAnyChunkLonger(compareString, maxChars),
      })}
    >
      {children}
    </Tag>
  )
}

export default ResponsiveText
